<template>
  <div>
    <ThePassIssuedExternalCouponNotification
      ref="ThePassIssuedExternalCouponNotification"
      :retry="retryIssuedExternalCoupon"
      :openCouponVersionWarning="openCouponVersionWarning"
      :isNotTargetVersion="isNotTargetVersion"
    />
    <TheMyticketHeader
      :ticketName="displayPassName(bookGroup, masterPass)"
      :clickBackButtonEvent="clickBackButtonEvent"
    />

    <div class="bg-img">
      <div class="content">
        <ThePassUpper />
      </div>

      <!-- ドットの線 -->
      <TheDotLine />

      <div class="the-pass-lower">
        <!-- デマンドの定期券は特別に予約するボタン -->
        <ThePassLowerDemand v-if="isDemandPass" />

        <!-- パス使用済み -->
        <FaceEndMessage v-else-if="isExpiredPass" />

        <!-- パス未使用(有効化前) -->

        <ThePassLowerBeforeValid
          v-else-if="countDown === null"
          :isAvailablePeriod="isAvailablePeriod"
          :showIssueExternalCouponNotification="
            showIssueExternalCouponNotification
          "
        />

        <!-- パス有効化後 -->
        <ThePassLowerAfterValid
          v-else-if="countDown !== null && countDown !== '00:00:00:00'"
          :countDown="countDown"
          :updatePassForQrTicketGate="updatePassForQrTicketGate"
        />
      </div>
    </div>

    <!-- Out of Using Time dialog -->
    <DialogPassOutOfUsingTimeWarning
      ref="DialogPassOutOfUsingTimeWarning"
      :okButtonClicked="onPassOutOfUsingTimeConfirm"
    />

    <DialogCouponVersionWarning ref="DialogCouponVersionWarning" />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import API from "@/API";

import myTicketsCommonService from "@/services/common/myTickets";
import nativeHandlerService from "@/services/nativeHandler";
import passService from "@/services/pass";

import moment from "@/services/moment";

export default {
  name: "TemplatePass",
  setup() {
    const store = useStore();

    const masterBook = store.getters["ticketing/masterBook"];
    const book = computed(() => store.getters["ticketing/book"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const pass = computed(() => store.getters["ticketing/pass"]);
    const masterPass = computed(() => store.getters["ticketing/masterPass"]);
    const isDemandPass = computed(() => {
      return (
        [332, 333, 337, 338, 372, 373].includes(masterPass.value.id) &&
        isAvailablePeriod.value
      );
    });

    const interval = ref(null);
    const intervalHideIssuedExternalCouponNotification = ref(null);
    const countDown = ref(null);
    const isAvailablePeriod = computed(() =>
      myTicketsCommonService.checkIsAvailablePeriod(
        book.value.available_started_at,
        book.value.available_limited_at
      )
    );
    // Passが有効かどうか？基本的にはカウントダウン制御だが、終了ボタンタイプはbookのis_expiredがtrueになるのでそれで判別
    const isExpiredPass = computed(
      () => countDown.value === "00:00:00:00" || book.value.is_expired
    );

    // QR改札チケットかどうか
    const isQrTicketGate = computed(() =>
      passService.checkIsQrTicketGate(pass.value)
    );
    const DialogPassOutOfUsingTimeWarning = ref(null);
    const ThePassIssuedExternalCouponNotification = ref(null);
    const DialogCouponVersionWarning = ref(null);

    const isNotTargetVersion = ref(false);
    const appVersion = computed(() => store.getters["common/appVersion"]);
    const device = computed(() => store.getters["common/device"]);

    onMounted(() => {
      updateCountDown();

      if (checkIsInUsingTime()) {
        setInterval(() => {
          if (!checkIsInUsingTime()) {
            window.location.reload();
          }
        }, 1 * 1000);
      } else if (checkIsBeforeEndTime()) {
        showPassOutOfUsingTimeDiaglog();
        return;
      }

      interval.value = setInterval(() => {
        updateCountDown();
      }, 1 * 1000);
    });

    const clickBackButtonEvent = async () => {
      // QR改札チケットで利用中の場合、MJとオムロンの同期のため、利用中の場合は閉じる際にgetPassをコールする
      if (!isExpiredPass.value && pass.value.is_valid && isQrTicketGate.value) {
        await API.getPass(pass.value.id);
      }
      // 画面輝度を元に戻す
      revertBrightnessOfScreen();
      nativeHandlerService.returnNativeAppMyticketPage();
    };

    // QR/QR改札チケットは、表示時に画面輝度を上げているので、期限切れ時や券面クローズ時に元に戻すための処理
    const revertBrightnessOfScreen = () => {
      if (
        isQrTicketGate.value ||
        passService.checkIsQrPass(masterPass.value) ||
        passService.checkIsOldQrPass(masterPass.value)
      ) {
        nativeHandlerService.ncRevertBrightness();
      }
    };

    // QR改札チケット用に、パス情報を再度取得してステータスを更新する処理
    const updatePassForQrTicketGate = async () => {
      await API.getPass(pass.value.id);

      // passが期限切れ(改札出場後)の場合、countDownを0にして使用済みとして扱う
      if (pass.value.is_expired) {
        countDown.value = "00:00:00:00";
      }
    };

    const updateCountDown = () => {
      // pass.user_limited_atが入ってから=pass有効化後に、countDownに値が入る
      if (pass.value.user_limited_at) {
        countDown.value = myTicketsCommonService.getCountDown(
          pass.value.user_limited_at
        );
      }
    };

    const showPassOutOfUsingTimeDiaglog = () => {
      console.log(
        "pass.using_started_at :>> ",
        pass.value.using_window[0].using_started_at
      );
      console.log(
        "pass.using_limited_at :>> ",
        pass.value.using_window[0].using_limited_at
      );
      DialogPassOutOfUsingTimeWarning.value.openDialog(pass.value);
    };

    const showIssueExternalCouponNotification = (isSuccess) => {
      ThePassIssuedExternalCouponNotification.value.showNotification(isSuccess);

      //reset 10s for retry action
      if (intervalHideIssuedExternalCouponNotification.value != null) {
        clearTimeout(intervalHideIssuedExternalCouponNotification.value);
      }

      intervalHideIssuedExternalCouponNotification.value = setTimeout(() => {
        ThePassIssuedExternalCouponNotification.value.hideNotification();
      }, 10 * 1000);
    };

    const retryIssuedExternalCoupon = async () => {
      try {
        const numberCouponIssued = await API.retryIssuedExternalCoupon(
          masterBook.id,
          book.value.id
        );
        if (numberCouponIssued >= 0) {
          showIssueExternalCouponNotification(true);
        }
      } catch (err) {
        showIssueExternalCouponNotification(false);
        console.log("retryIssuedExternalCoupon :>> issue coupon fail");
      }
    };

    const onPassOutOfUsingTimeConfirm = () => {
      nativeHandlerService.returnNativeAppMyticketPage();
    };

    const checkIsBeforeEndTime = () => {
      const endTime =
        book.value.user_limited_at != null
          ? book.value.user_limited_at
          : book.value.available_limited_at;

      var current = moment(new Date());
      return current.isBefore(new Date(endTime));
    };

    const checkIsInUsingTime = () => {
      const isInUsingTime = myTicketsCommonService.checkPassIsAvailablePeriod(
        pass.value
      );
      return isInUsingTime;
    };

    const openCouponVersionWarning = () => {
      DialogCouponVersionWarning.value.openDialog();
    };

    // 対象のバージョンかどうか確認
    const checkVersion = () => {
      let bool = false;
      switch (device.value) {
        case "IOS":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.1");
          break;
        case "ANDROID":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.1");
          break;
        default:
          bool = false;
          break;
      }
      isNotTargetVersion.value = bool;
    };

    // x.x.x(string)のバージョンを、比較用の数値に変換する
    const convertVersionForCompare = (ver) => {
      const verNums = ver.split(".");
      return verNums[0] * 100 + verNums[1] * 10 + verNums[2];
    };

    watchEffect(() => {
      // 期限切れになった場合、以降のステータスの変動はないのでカウントダウン計算を止める
      // また、画面輝度を元に戻す
      if (isExpiredPass.value) {
        clearInterval(interval.value);
        revertBrightnessOfScreen();
      }

      if (appVersion.value != null && appVersion.value != undefined) {
        checkVersion();
      }
    });

    return {
      countDown,
      isAvailablePeriod,
      isExpiredPass,
      book,
      bookGroup,
      pass,
      masterPass,
      isDemandPass,
      clickBackButtonEvent,
      updatePassForQrTicketGate,
      showPassOutOfUsingTimeDiaglog,
      onPassOutOfUsingTimeConfirm,
      checkIsInUsingTime,
      checkIsBeforeEndTime,
      DialogPassOutOfUsingTimeWarning,
      showIssueExternalCouponNotification,
      retryIssuedExternalCoupon,
      isNotTargetVersion,
      openCouponVersionWarning,
      ThePassIssuedExternalCouponNotification,
      DialogCouponVersionWarning,
    };
  },
};
</script>
